export class CdFdTaskTypes {

    static PkSignExecutiveDocumentationAgreementWithAgreementorTypeID = "3374af53-e46a-45b5-bfe2-b5e4b9f1cd58";
    static PkSignExecutiveDocumentationAgreementTypeID = "81f44c81-a246-4bb3-872e-23a05b8075d7";
    static PkSignExecutiveDocumentationCoordinationAuthorSupervisionTypeID = "a46af768-2442-4435-865f-aaaa44de6381";
    static PkSignExecutiveDocumentationInitializingTypeID = "1364AA05-22FD-414C-B82F-A06C4F651BD8";
    static PkExecutiveDocumentationAgreementWithAgreementorTypeID = "4E652BE7-B6C0-4011-A523-F62A9E27650D";
    static PkFdInArchiveTypeID = "89B8980B-76A1-4FED-B569-E144027B01A6";
    static PkExecutiveDocumentationInitializingTypeID = "91AEA9E4-44F8-45B9-952F-35A1F989F7A3";
    static PkExecutiveDocumentationToReworkTypeID = "E468E9C1-1379-4C5A-B4EF-BF9A37BAD112";


    static PkSignExecutiveSchemeAgreementWithAgreementorTypeID = "94e0f510-2179-4b63-88f8-36971b074b82";
    static PkSignExecutiveSchemeAgreementTypeID = "1645238b-becc-4e44-b79a-c1d0561c2538";
    static PkSignExecutiveSchemeInitializingTypeID = "44136c83-d768-4d5c-925e-bbbdf38e1f08";
    static PkExecutiveSchemeToReworkTypeID = "25015128-2f71-41df-85e0-2cb54bced00a";
    static PkExecutiveSchemeCancelTypeID = "e8563f9b-3130-42e0-ad17-f4d3b5615ddb";
    static PkExecutiveSchemeCanUseInEDActsTypeID = "58c79101-1c0e-4633-b806-c6e9c5067d04";

    static PkDevelopmentScenarioInitializingTypeID = "918d8ea0-6339-4fa8-8534-bc1be878de51";
    static PkDevelopmentScenarioAgreementWithAgreementorTypeID = "218acbec-bba1-44c2-8c38-f6442b9c6db2";
    static PkDevelopmentScenarioToReworkTypeID = "61b9154a-7eb0-48e1-88d9-ae73ac4300b8"; 

    static PkSignRequestForMaterialsInitializingTypeID = "8fbf9087-4255-4a56-a262-641bce39c944";
    static PkSignRequestForMaterialsToReworkTypeID = "3d383911-6c7b-4e78-bb46-3d156c943d0a";
    static PkSignRequestForMaterialsSigningTypeID = "1805915f-60ca-4c25-92ee-993b7919e080"
    static PkSignRequestForMaterialsEngeneerPTOSigningTypeID = "aeef1b9d-2579-4c0e-a0d7-73b84c5fd969"

    static PkTechnicalDocumentationAgreementOnRenovationInFRTypeID = "D33AF34E-5B89-4046-9AA5-C9AB472122C3";

    static PkSignInDiadocTypeID = "3157fde3-a311-4754-98bb-07b04c07dfd1";
    static PkProcessIncomingResponseTypeID = "35edfcfc-22a4-4289-a6ad-8df5042e15d7";
    static PkReworkTaskTypeID = "cfa7cc6c-3de0-430b-b967-7e89c71a0c97";
  }